import axios from 'axios';
import QS from 'qs';
import { message } from 'antd'

export const imageUrl = `https://api.zeus.ipcn.cn/ucs/file/`;
export const zeusApp = 'APP004';
export const basciUrl = 'https://api.zeus.ipcn.cn'
// export const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL || 'http://localhost:42007/zeus/api/ucs/file/';
// export const zeusApp = process.env.REACT_APP_ZEUS_APP || 'APP001';
// export const basciUrl = process.env.REACT_APP_API_URL || 'http://localhost:42007/zeus/api';

const service = axios.create({
    baseURL: basciUrl
})

// 请求拦截器
service.interceptors.request.use(config => {
    const token = localStorage.getItem('userToken') || '';

    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json; charset=utf-8';

    config.headers['zeus-app'] = zeusApp;
    config.headers['zeus-token'] = token;

    if (config.method === 'get') {
        config.params = config.params || {};
    }
    // if (config.method === 'post' || config.method === 'put') {
    //     if (config.headers['Content-Type'].includes('application/x-www-form-urlencoded')) {
    //         config.data = QS.stringify(config.data);
    //     }else if (config.headers['Content-Type'].includes('application/json')) {
    //         config.data = JSON.stringify(config.data); // 删除这行
    //     }
    // }

    if (config.method === 'post' || config.method === 'put') {
        if (config.headers['Content-Type'].includes('application/x-www-form-urlencoded')) {
            config.data = QS.stringify(config.data);
        } else if (config.headers['Content-Type'].includes('application/json')) {
            // config.data = JSON.stringify(config.data); // 删除这行
        }else{
        }
    }

    return config
}, error => {
    return Promise.reject(error);
})

// 响应拦截器
service.interceptors.response.use(response => {
    if (response.code) {
        switch (response.code) {
            case 200:
                return response.data;
            case 401:
                //未登录
                break;
            case 403:
                message.error('Token 已过期，请重新登录');
                window.localStorage.removeItem('userToken');
                window.sessionStorage.removeItem('userToken');
                break;
            default:
                message.error(response.data.msg)
        }
    } else {
        return response;
    }
})

export default service